<ag-grid-angular style="width: 100%; height: 60vh;" class="ag-theme-alpine ag-grid-withoutTopBorder "
    [columnDefs]="columnDefs" [animateRows]="true" [rowData]="rowData" (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions" [headerHeight]="30" [rowHeight]="30">
</ag-grid-angular>
